
export const useSelectors = () => {
    const formatSelectors = (items) => {
        const formattedItems = []

        for (let i = 0; i < items.length; i++) {
            let type;
            if (i === 0) {
                type = 'ETHOS'
            }

            if (i === 1) {
                type = 'PATHOS'
            }

            if (i === 2) {
                type = 'LOGOS'
            }
            const formattedItem = {
                type: type,
                id: items[i].hint,
                text: items[i].text,
                response: items[i].response
            }
            formattedItems.push(formattedItem)
        }
        return formattedItems
    }
    /**
     * { type: 'ETHOS', id: 'TODO-id', text: 'eetosta eetosta' },
            { type: 'PATHOS', id: 'TODO-id', text: 'paatosta paatosta' },
            { type: 'LOGOS', id: 'TODO-id', text: 'loogosta loogosta' }
     */

    return {
        formatSelectors
    }
}